import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { CalendarDays } from "lucide-react";

const pad = (n) => String(n).padStart(2, "0");

// value: "yyyy-mm-dd" string (backend format). Displays dd-mm-yyyy (Indian format).
export function DateField({ value, onChange, className = "", testid, placeholder = "dd-mm-yyyy" }) {
  const [open, setOpen] = useState(false);

  let selected;
  let display = placeholder;
  if (value && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [y, m, d] = value.split("-").map(Number);
    selected = new Date(y, m - 1, d);
    display = `${pad(d)}-${pad(m)}-${y}`;
  }

  const handleSelect = (date) => {
    if (date) {
      onChange(`${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`);
    }
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" data-testid={testid}
          className={`justify-start text-left font-normal ${!value ? "text-muted-foreground" : ""} ${className}`}>
          <CalendarDays className="mr-2 h-4 w-4" />
          {display}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" selected={selected} onSelect={handleSelect} initialFocus />
      </PopoverContent>
    </Popover>
  );
}
